import store from '@/plugins/store'
import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import { GetImportantDocumentsCommand } from '@/app/important-documents/commands/get-important-documents.command'
import { DownloadImportantDocumentCommand } from '@/app/important-documents/commands/download-important-document.command'

const httpClient = new AxiosClient()

export const getImportantDocumentsCommand = new GetImportantDocumentsCommand(httpClient, store)
export const downloadImportantDocumentCommand = new DownloadImportantDocumentCommand(httpClient, store)
